import moment from 'moment';

import { CONTRATO } from '../../../../constants/tipoContrato';
import { esquemaEmpleado } from '../schemas/empleadoSchema';
import { validarEsquemas } from './validarEsquemaHelper';
import { validarReglasNegocio } from './reglasNegocioHelper';
import { calcularEstadoEmpleado } from './calcularEstadoHelper';

/**
 * Orquesta la validación completa de un empleado y calcula sus estados derivados.
 * @param {Object} empleado - Datos del empleado.
 * @param {number} lineaIndex - Índice de la fila en el archivo.
 * @param {Object} contexto - Datos externos (tiposDocumentos, tiposContratos, etc).
 * @returns {Object} { errores: Array, empleado: Object, esSena: boolean }
 */
export const validarEmpleadoHelper = (empleado, lineaIndex, contexto) => {
  const fechaActual = moment.utc();
  const fechaIngreso = moment(empleado.FechaIngreso, 'YYYY-MM-DD', true);
  const fechaHasta = moment(empleado.FechaContratoHasta, 'YYYY-MM-DD', true);

  const errores = [
    ...validarEsquemas(empleado, lineaIndex, contexto, esquemaEmpleado),
    ...validarReglasNegocio(
      empleado,
      contexto,
      fechaIngreso,
      fechaHasta,
      lineaIndex
    ),
  ];

  const estadosCalculados = calcularEstadoEmpleado(
    empleado,
    fechaIngreso,
    fechaHasta,
    fechaActual
  );

  const empleadoProcesado = {
    ...empleado,
    ...estadosCalculados,
  };

  return {
    errores,
    empleado: empleadoProcesado,
    esSena: empleadoProcesado.TipoContrato === CONTRATO.APRENDIZAJE,
  };
};
